import React, { Component } from 'react';
import LiveRoomGiftFields from './LiveRoomGiftFields';
const localTime = value => value == null ? '' : new Date(value + 7 * 60 * 60 * 1000).toISOString().slice(0, 16);
const epochTime = value => value ? Date.parse(value + (value.length === 16 ? ':00' : '') + '+07:00') : null;

class BackgroundModal extends Component {
    render() {
        const { 
            show, 
            isEditMode, 
            formData, 
            categoryType,
            loading, 
            onClose, 
            onSave, 
            onInputChange, 
            renderImageUpload 
        } = this.props;

        if (!show) return null;

        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEditMode ? 'Sửa nền phòng' : 'Thêm nền phòng mới'}
                                </h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={onClose}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6 form-group"><label>Bắt đầu (giờ Việt Nam, không bắt buộc)</label>
                                        <input type="datetime-local" step="60" className="form-control" disabled={formData.id === 1111111111 || loading}
                                            value={localTime(formData.startTime)} onChange={e => onInputChange('startTime', epochTime(e.target.value))} />
                                        <small>Để trống: không giới hạn bắt đầu</small>
                                    </div>
                                    <div className="col-md-6 form-group"><label>Kết thúc (giờ Việt Nam, không bắt buộc)</label>
                                        <input type="datetime-local" step="60" className="form-control" disabled={formData.id === 1111111111 || loading}
                                            value={localTime(formData.endTime)} onChange={e => onInputChange('endTime', epochTime(e.target.value))} />
                                        <small>Để trống: không giới hạn kết thúc</small>
                                    </div>
                                </div>
                                {categoryType === 'ROOM_GIFT' && <LiveRoomGiftFields liveRooms={formData.liveRooms || []} disabled={loading}
                                    errors={this.props.invalidLiveRooms || []} onDraftChange={this.props.onDraftChange}
                                    onChange={liveRooms => onInputChange('liveRooms', liveRooms)} />}
                                {categoryType === 'ROOM_GIFT' && <div className="form-group">
                                    <label className="form-label">Tag</label>
                                    <input type="text" className="form-control" value={formData.tag || ''}
                                        onChange={e => onInputChange('tag', e.target.value)} disabled={loading}
                                        maxLength="100"
                                        placeholder="Nhập tag hiển thị cho nền được tặng" />
                                </div>}

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label required">Tên nền phòng</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.name}
                                                onChange={(e) => onInputChange('name', e.target.value)}
                                                placeholder="Nhập tên nền phòng"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{display: categoryType === 'ROOM_GIFT' ? 'none' : undefined}}>
                                        <div className="form-group">
                                            <label className="form-label required">Level</label>
                                            <input
                                                type="number"
                                                min="1"
                                                className="form-control"
                                                value={formData.level}
                                                onChange={(e) => onInputChange('level', parseInt(e.target.value) || 1)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="form-label required">Màu nền</label>
                                            <div className="color-input-group">
                                                <input
                                                    type="color"
                                                    className="form-control color-picker"
                                                    value={formData.color}
                                                    onChange={(e) => onInputChange('color', e.target.value)}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control color-hex-input"
                                                    value={formData.color}
                                                    onChange={(e) => onInputChange('color', e.target.value)}
                                                    placeholder="#FF6B6B"
                                                    maxLength="7"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="form-label required">Trạng thái</label>
                                            <select
                                                className="form-control no-padding"
                                                value={formData.status}
                                                onChange={(e) => onInputChange('status', parseInt(e.target.value))}
                                            >
                                                <option value={1}>Hiện</option>
                                                <option value={0}>Ẩn</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        {renderImageUpload('background', 'Background', false)}
                                    </div>
                                    <div className="col-md-6">
                                        {renderImageUpload('stage', 'Bục sân khấu', false)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        {renderImageUpload('solo_stage', 'Bục hát Đơn ca', false)}
                                    </div>
                                    <div className="col-md-6">
                                        {renderImageUpload('duet_stage', 'Bục hát Song ca', false)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        {renderImageUpload('thumbnail', 'Ảnh thumbnail nền phòng', false)}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                >
                                    Hủy
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary"
                                    onClick={onSave}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="loading-spinner"></span>
                                            Đang lưu...
                                        </>
                                    ) : (
                                        isEditMode ? 'Cập nhật' : 'Thêm mới'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div 
                    className="modal-backdrop fade show"
                    onClick={onClose}
                ></div>
            </>
        );
    }
}

export default BackgroundModal;
